import { faArrowUpFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import zoomIcon from 'src/assets/img/icon-integration-zoom.svg';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { Link } from 'src/components/Link';
import { ListItem } from 'src/components/ListItem';
import { Typography } from 'src/components/Typography';

export const ZoomListItem = ({ appointment }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'admin.platform.appointment.drawer',
  });

  return (
    <>
      {appointment.zoomMeeting && (
        <Box mb={2}>
          <ListItem
            indent="large"
            centerIndent
            onClick={() => {
              window.open(appointment.zoomMeeting.joinUrl, '_blank');
            }}
            primary={
              <Typography fontWeight={300}>{t('joinMeeting')}</Typography>
            }
            leftAdornment={
              <Box component={'img'} src={zoomIcon} height={24} width={24} />
            }
            rightAdornment={
              <IconButton
                component={Link}
                target="_blank"
                href={appointment.zoomMeeting.joinUrl}
              >
                <Icon
                  icon={faArrowUpFromSquare}
                />
              </IconButton>
            }
          />
        </Box>
      )}
    </>
  );
};
